import '../../styles/main.css';
import React from 'react';
import CalculadoraForm from '@divina/calculadora-comercio';
import icon from '../../assets/icon.png';
import BudgetSender from '../BudgetSender';

class Comercio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      policyId: 101,
      response: null,
    };
  }

  showBudget = (value, ...params) => {
    this.setState({
      response: value,
    });
  };

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <div className="main-title">
          <div className="wrapper">
            <span className="main-title__text">
              Cuánto costaría el seguro de Comercio
            </span>
            <div className="main-title__icon">
              <img
                src={icon}
                alt="Icono Comercio"
                style={{ verticalAlign: 'top' }}
              />
            </div>
          </div>
        </div>
        <div style={{ maxWidth: '800px', margin: '50px auto' }}>
          <CalculadoraForm
            policyId={this.state.policyId}
            onCalculated={this.showBudget}
          />
        </div>
        {this.state.response ? (
          <BudgetSender
            calculatorForm={this.state.response}
            product={this.props.product}
          />
        ) : null}
      </div>
    );
  }
}

export default Comercio;



// WEBPACK FOOTER //
// ./src/components/Comercio/index.js